import { render, staticRenderFns } from "./TabAll.vue?vue&type=template&id=437bfb55&scoped=true&"
import script from "./TabAll.vue?vue&type=script&lang=js&"
export * from "./TabAll.vue?vue&type=script&lang=js&"
import style0 from "./TabAll.vue?vue&type=style&index=0&id=437bfb55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437bfb55",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
